import { useDispatch, useSelector } from 'react-redux';
import { setLocationData } from '../../../../store/actions/location';
import { useCallback } from 'react';

export const useZoneValidation = () => {
  const dispatch = useDispatch();
  const location_data = useSelector((state) => state.location.location_data || []);
  const errors = useSelector((state) => state.location.location_data.zoneErrors);
  const selectedFile = useSelector((state) => state.location.location_data.selectedFile);
  const zoneId = useSelector((state) => state.location.location_data.newZones?.[selectedFile?.id]?.zone_id_selected);
  const validateZoneFields = useCallback(() => {
    let tempErrors = { ...errors };
    // if (selectedFile == null) {
    //   tempErrors['locationNameDropDownFloor'] = 'Please select floor';
    // } else {
    //   tempErrors['locationNameDropDownFloor'] = '';
    // }
    tempErrors['locationNameDropDownFloor'] = '';

    let floorsNameWithErrors = {};
    let floorsZoneCoordWithErrors = {};
    for (const floor of Object.values(location_data?.floors)) {
      const zonesNameWithErrors = [];
      const zonesCoordWithErrors = [];
      // if (floor?.zones) {
        // if (!(Object.keys(floor?.zones)?.length > 0)) {
        //   zonesNameWithErrors.push('no_zones');
        //   zonesCoordWithErrors.push('no_zones');
        //   floorsNameWithErrors[floor?.id] = zonesNameWithErrors;
        //   floorsZoneCoordWithErrors[floor?.id] = zonesCoordWithErrors;
        // } else {
          if (floor?.zones) {
          for (const zone of Object.values(floor?.zones)) {
            if ((!zone?.zone_name || zone?.zone_name?.trim() === '' || zone?.zone_name?.length < 3 || zone?.zone_name?.length > 30) && !((!zone?.zone_name || zone?.zone_name?.trim() === '') && (!zone?.zone_coordinates || zone?.zone_coordinates?.length === 0))) {
              zonesNameWithErrors.push(zone?.zone_id);
            }
          }
          if (zonesNameWithErrors?.length > 0) {
            floorsNameWithErrors[floor?.id] = zonesNameWithErrors;
          }
          for (const zone of Object.values(floor?.zones)) {
            if ((!zone?.zone_coordinates || zone?.zone_coordinates?.length < 3) && !((!zone?.zone_name || zone?.zone_name?.trim() === '') && (!zone?.zone_coordinates || zone?.zone_coordinates?.length === 0))) {
              zonesCoordWithErrors.push(zone?.zone_id);
            }
          }
          if (zonesCoordWithErrors?.length > 0) {
            floorsZoneCoordWithErrors[floor?.id] = zonesCoordWithErrors;
          }
        }
        //}
      // } else {
      //   zonesNameWithErrors.push('no_zones');
      //   zonesCoordWithErrors.push('no_zones');
      //   floorsNameWithErrors[floor?.id] = zonesNameWithErrors;
      //   floorsZoneCoordWithErrors[floor?.id] = zonesCoordWithErrors;
      // }
    }

    if (Object.keys(floorsNameWithErrors)?.length > 0) {
      tempErrors['zoneName'] = 'Please enter zone name for following floors: ' +
        Object.keys(floorsNameWithErrors)
          .filter(floorKey => floorsNameWithErrors?.[floorKey]?.length > 0)
          .map(floorKey => location_data?.floors?.[floorKey]?.name)
          .join(', ');
    } else {
      tempErrors['zoneName'] = '';
    }

    if (Object.keys(floorsZoneCoordWithErrors)?.length > 0) {
      tempErrors['zoneCoordinates'] = 'Please draw zone on map for following floors: ' +
        Object.keys(floorsZoneCoordWithErrors)
          .filter(floorKey => floorsZoneCoordWithErrors?.[floorKey]?.length > 0)
          .map(floorKey => location_data?.floors?.[floorKey]?.name)
          .join(', ');
    } else {
      tempErrors['zoneCoordinates'] = '';
    }

    if (location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway === true) {
      if (!location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.gateway_id) {
        tempErrors['GatewayDropDown'] = 'Please select gateway';
      } else {
        tempErrors['GatewayDropDown'] = '';
      }
      if (!location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.gateway_profile_id) {
        tempErrors['GatewayProfileDropDown'] = 'Please select gateway profile';
      } else {
        tempErrors['GatewayProfileDropDown'] = '';
      }
    } else {
      tempErrors['GatewayDropDown'] = '';
      tempErrors['GatewayProfileDropDown'] = '';
    }
    tempErrors['initial'] = false;
    // Set validation flag in location_data
    const isValid = !Object.values(tempErrors).some((x) => x !== '' && x !== "initial" && x !== false);
    dispatch(setLocationData({
      ...location_data,
      zoneValidationFlag: isValid,
      zoneErrors: tempErrors,
    }));

    return isValid;
  }, [dispatch, location_data, errors]);

  return { validateZoneFields };
};